import { useState } from "react";
import { FaPhone } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { Ri24HoursFill } from "react-icons/ri";
import logo from "../images/aombre-logo.png";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const handleSubscribe = async () => {
    if (!email) {
      setPopupMessage("Please enter a valid email.");
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 3000);
      return;
    }

    if (localStorage.getItem("subscribedEmail") === email) {
      setPopupMessage("You have already subscribed");
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 3000);
      return;
    }

    setLoading(true);
    try {
      const baseUrl = process.env.REACT_APP_API_BASE_URL;
      const response = await fetch(`${baseUrl}subscribe`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setPopupMessage("Thank you for subscribing!");
        localStorage.setItem("subscribedEmail", email);
        setEmail(""); // clear input
      } else {
        setPopupMessage("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error(error);
      setPopupMessage("Unable to subscribe at the moment. Please try later.");
    }

    setShowPopup(true);
    setTimeout(() => setShowPopup(false), 3000);
    setLoading(false);
  };

  return (
    <footer className="bg-[#006039] text-gray-200 text-sm pt-10 px-6 md:px-20 relative no-print">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Important Links */}
        <div>
          <h3 className="text-lg font-semibold mb-3">Important Links</h3>
          <ul className="space-y-2">
            <li>
              <a href="/vehicles" className="hover:underline">
                Our Fleet
              </a>
            </li>
            <li>
              <a href="/policy" className="hover:underline">
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="/locations" className="hover:underline">
                Rental Locations
              </a>
            </li>
            <li>
              <a href="/offers" className="hover:underline">
                Promotions & Discounts
              </a>
            </li>
            <li>
              <a href="/rental-policy" className="hover:underline">
                Rental Policy
              </a>
            </li>
          </ul>
        </div>

        {/* Customer Support */}
        <div>
          <h3 className="text-lg font-semibold mb-3">Customer Support</h3>
          <ul className="space-y-2">
            <li>
              <a>24/7 Help Center</a>
            </li>
            <li>
              <a href="/contact" className="hover:underline">
                Contact Us
              </a>
            </li>
          </ul>
        </div>

        {/* Connect With Us */}
        <div>
          <h3 className="text-lg font-semibold mb-3">Connect With Us</h3>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center gap-2">
              <FaPhone className="text-[#ca8032]" />
              <a href="tel:" className="hover:underline uppercase">
                +1-(888) 980-4410
              </a>
            </li>
            <li className="flex items-center gap-2">
              <MdEmail className="text-[#ca8032]" />
              <a href="mailto:care@aombre.com" className="hover:underline">
                care@aombre.com
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Ri24HoursFill className="text-[#ca8032]" />
              <span>Hours: 24/7 Customer Service</span>
            </li>
          </ul>
        </div>

        {/* Logo & Newsletter */}
        <div className="flex flex-col items-start md:items-end">
          <div className="w-full md:w-64">
            <h4 className="font-semibold mb-2">Subscribe to Our Offers</h4>
            <p className="mb-2 text-gray-400">
              Get exclusive deals delivered straight to your inbox.
            </p>
            <div className="flex items-center space-x-2">
              <input
                type="email"
                placeholder="Your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-3 py-2 rounded bg-gray-800 border border-gray-600 text-white placeholder-gray-400"
              />
              <button
                onClick={handleSubscribe}
                disabled={loading}
                className="bg-[#ca8032] hover:bg-yellow-600 text-white font-semibold px-4 py-2 rounded disabled:opacity-50"
              >
                {loading ? "Subscribing..." : "Subscribe"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Footer bottom */}
      <div className="mt-10 border-t border-gray-700 pt-6 pb-4 text-center text-xs text-gray-400">
        © 2026 Aombre Car Rental. All rights reserved.
        {/* |{" "}
        <a href="/policy" className="hover:underline">
          Privacy Policy
        </a>{" "}
        {" "} */}
        {/* <a href="/terms" className="hover:underline">
          Terms & Conditions
        </a> */}
      </div>

      {/* Popup */}
      {showPopup && (
        <div className="fixed bottom-20 right-20 bg-[#ca8032] text-white px-5 py-3 rounded shadow-lg animate-slide-in">
          {popupMessage}
        </div>
      )}

      {/* Tailwind animation */}
      <style>
        {`
          @keyframes slide-in {
            0% { transform: translateY(100%); opacity: 0; }
            100% { transform: translateY(0); opacity: 1; }
          }
          .animate-slide-in {
            animation: slide-in 0.3s ease-out;
          }
        `}
      </style>
    </footer>
  );
};

export default Footer;
